import { setListener } from "@front/utils";
import { createComponent } from "@front/utils/alpine";

export default createComponent(() => ({
    init() {
        setListener((this.$refs.btn), 'click', (el) => {
            document.body.scrollIntoView({behavior: 'smooth'});
        });
    },

    scroll() {
        if(window.scrollY > 100) {
            this.$el.classList.remove('opacity-0', 'pointer-events-none');
        } else {
            this.$el.classList.add('opacity-0', 'pointer-events-none');
        }
    },
}));